angular.module('tgaAdmin', [
  'environment',
  'LocalStorageModule',
  'ui.router',
  'ui.bootstrap',
  'countUpModule',
  'smart-table',
  'ngSanitize',
  'ngCsv',
  'daterangepicker',
  'ui.sortable',
  'naif.base64',
  'slugifier',
  'infinite-scroll',
  'ngAnimate',
  'angular-stripe',
  'payment',
  'ngCookies',
  'angular-clipboard',
  'colorpicker.module',
  'ngPapaParse',
  'moment-picker',
  'ui.select',
  'ngQuill',
  'angular-intro',
  'ngFileUpload',
  'ui.swiper',
  'pascalprecht.translate',
  'btford.socket-io',
]).controller('AppController', [
  '$scope', '$rootScope', '$window', '$state', '$location', 'userService', '$uibModalStack',
  'settingsService', 'domainService', 'IdleTimer', 'modalService', 'flashService', 'envService',
  'httpPendingRequestService', 'tzService', 'quillTooltipService', 'stateHistoryService', '$translate',
  'analyticsService',
  function (
    $scope, $rootScope, $window, $state, $location, userService, $uibModalStack,
    settingsService, domainService, IdleTimer, modalService, flashService,
    envService, httpPendingRequestService, tzService, quillTooltipService, stateHistoryService, $translate,
    analyticsService,
  ) {
    $scope.data = {
      settings: {},
      company: null,
      postLogin: null,
    };

    $scope.root = $rootScope;
    $scope.root.date = new Date();
    $scope.state = $state;

    $translate.use('en');

    $rootScope.onEditorCreated = (editor) => {
      quillTooltipService.showTooltips(editor);
    };

    $scope.initialize = () => {
      settingsService.getSettings().then(
        (settings) => {
          $scope.data.settings = settings;
          $scope.data.company = settings.company;

          if ($scope.state.current && $scope.state.current.data) {
            $window.document.title = $scope.state.current.data.title;

            if ($scope.data.company) {
              $window.document.title += ` | ${$scope.data.company}`;
            }
          }
        },
      );

      // User is logged in, ensure timezone has been loaded.
      if (userService.isLoggedIn()) {
        tzService.setUserTimezone(userService.getUserData()?.timezone);
      }

      analyticsService.init();
    };

    $rootScope.actions = {
      logout: () => {
        $rootScope.loading = true;
        domainService.checkSSO().then(
          (response) => {
            userService.logout();

            if (response.sso && response.logout) {
              // SSO logout (SLO)
              $window.location.href = response.logout;
            } else {
              // Normal logout
              $rootScope.loading = false;
              $state.go('v1.login', {
                reload: true,
              });
            }
          },
          () => {
            // Fallback to normal logout
            userService.logout();
            $rootScope.loading = false;
            $state.go('v1.login', {
              reload: true,
            });
          },
        );
      },
    };

    if (envService.is('production')) {
      const activityMonitor = new IdleTimer();
      activityMonitor.options.inactive = $scope.data.settings.admin_timeout || 3600; // 60 mins
      activityMonitor.options.keepAlive = activityMonitor.options.inactive - 180; // -3 mins
      activityMonitor.options.warning = 60;
      activityMonitor.options.disableOnInactive = false;

      activityMonitor.on('inactive',
        () => {
          if (!userService.isLoggedIn()) {
            return;
          }

          if ($scope.data.settings.admin_timeout || userService.getUserData().user_type === 'super_admin') {
            $uibModalStack.dismissAll();
            const msg = '<span class="fa fa-exclamation-triangle"></span> You have been logged out due to inactivity.';
            flashService.set(msg, 'warning', true);
            $rootScope.actions.logout();
          }
        });

      activityMonitor.on('warning',
        () => {
          if (!userService.isLoggedIn()) {
            return;
          }

          if ($scope.data.settings.admin_timeout || userService.getUserData().user_type === 'super_admin') {
            if (!$uibModalStack.getTop()) {
              modalService.showModal({
                title: 'Warning!',
                message: 'Your session is about to expire! Please resume activity to prevent from being logged out.',
                closeButton: null,
              }, {
                backdrop: true,
                keyboard: true,
                animation: false,
              }).catch(angular.noop);
            }
          }
        });
    }

    const stateChangeStart = $rootScope.$on('$stateChangeStart',
      // eslint-disable-next-line consistent-return
      (event, toState, toParams, fromState) => {
        stateHistoryService.add(fromState.name);
        if (toState.name !== fromState.name) {
          httpPendingRequestService.cancelAll();
        }

        if ($uibModalStack.getTop()) {
          if ($uibModalStack.getTop().value.backdrop !== 'static') {
            $uibModalStack.dismissAll();
          }
          event.preventDefault();
        }

        // All registration goes through 'setup' domain for consistency
        // (i.e., we don't want people accessing registration under a custom domain)
        if (toState.name === 'v1.register' && domainService.domain !== 'setup') {
          event.preventDefault();
          const href = `${$window.location.protocol}//setup.${domainService.base}${$window.location.pathname}`;
          $window.location.href = href;
        }

        if (toState.name !== 'v1.register' && domainService.domain === 'setup') {
          event.preventDefault();
          return $state.go('v1.register');
        }

        if (
          toState.name !== 'v1.login-common'
          && toState.name !== 'v1.forgot'
          && toState.name !== 'v1.reset'
          && domainService.domain === 'login'
        ) {
          event.preventDefault();
          return $state.go('v1.login-common');
        }

        // whitelist urls that don't require authentication
        switch (toState.name) {
          case 'v1.login':
          case 'v1.login-common':
          case 'v1.login-two-factor':
          case 'v1.register':
          case 'v1.forgot':
          case 'v1.reset':
          case 'v1.connect':
          case 'v1.embed':
            // eslint-disable-next-line consistent-return
            return;
          default:
            if (!userService.isLoggedIn()) {
              event.preventDefault();
              // Save original route/params to resume after login
              $scope.data.postLogin = {
                state: toState,
                params: toParams,
              };

              if ($location.search().api_key) {
                return $state.go('v1.embed', toParams, { reload: true });
              }
              return $state.go('v1.login', toParams, { reload: true });
            }

            if ($scope.data.postLogin) {
              event.preventDefault();
              const postLogin = angular.copy($scope.data.postLogin);
              $scope.data.postLogin = null;
              return $state.go(postLogin.state.name, postLogin.params, { reload: true, location: 'replace' });
            }

            if (toState.data.allowedUsers && !userService.checkUserType(toState.data.allowedUsers)) {
              event.preventDefault();
              return $state.go('v1.games');
            }
        }
      });

    const stateChangeError = $rootScope.$on('$stateChangeError',
      // eslint-disable-next-line consistent-return
      (event, toState, toParams, fromState, fromParams, error) => {
        if (angular.isObject(error) && angular.isString(error.code)) {
          switch (error.code) {
            case 'EXPIRED':
              modalService.showModal({
                title: 'Subscription Expired',
                message: 'Upgrade your account to access this game.',
                closeButton: false,
                actionButton: 'OK',
              });
              break;
            default:
              break;
          }
        } else if (error.message === 'Invalid game.' && toState.name === 'v1.editGame') {
          event.preventDefault();
          return $state.go('v1.games');
        }
      });

    const stateChangeSuccess = $rootScope.$on('$stateChangeSuccess',
      (event, toState) => {
        if ($window.ga) {
          $window.ga('send', 'pageview', { page: $location.path() });
        }

        $window.document.title = toState.data.title;

        if ($scope.data.company) {
          $window.document.title += ` | ${$scope.data.company}`;
        }

        if ($location.search().hide_menu) {
          $rootScope.fullscreen = true;
        }
      });

    const refreshSettings = $rootScope.$on('refreshSettings',
      () => {
        $scope.initialize();
      });

    $scope.$on('fullscreen',
      (e, args) => {
        $rootScope.fullscreen = args;
      });

    $scope.$on('$destroy', () => {
      stateChangeStart();
      stateChangeError();
      stateChangeSuccess();
      refreshSettings();
    });

    // Add analytics in production
    if (envService.is('production')) {
      (function (i, s, o, g, r, a, m) {
        // eslint-disable-next-line no-unused-expressions
        i.GoogleAnalyticsObject = r; i[r] = i[r] || function () {
          // eslint-disable-next-line prefer-rest-params
          (i[r].q = i[r].q || []).push(arguments);
        // eslint-disable-next-line no-unused-expressions, no-sequences
        }, i[r].l = 1 * new Date(); a = s.createElement(o),
        m = s.getElementsByTagName(o)[0]; a.async = 1; a.src = g; m.parentNode.insertBefore(a, m);
      }(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga'));

      // eslint-disable-next-line no-undef
      ga('create', 'UA-93253700-1', 'auto');
    }

    $scope.initialize();
  },
]);
